(function () {
  var lockClass = 'klaviyo-prevent-body-scrolling';
  var checkTimer;

  function isVisible(element) {
    if (!element) return false;
    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      Number(styles.opacity) !== 0 &&
      rect.width > 0 &&
      rect.height > 0;
  }

  function hasVisibleKlaviyoModal() {
    var selectors = [
      '.klaviyo-form',
      '.klaviyo-bis-modal',
      '#klaviyo-bis-modal',
      '[data-testid="form-component"]',
      '[data-testid*="klaviyo"]',
      '[role="dialog"].needsclick',
      '.needsclick[role="dialog"]'
    ];

    return Array.from(document.querySelectorAll(selectors.join(','))).some(isVisible);
  }

  function releaseOrphanedLock() {
    checkTimer = undefined;
    if (!document.body.classList.contains(lockClass)) return;
    if (!hasVisibleKlaviyoModal()) document.body.classList.remove(lockClass);
  }

  function scheduleCheck() {
    window.clearTimeout(checkTimer);
    checkTimer = window.setTimeout(releaseOrphanedLock, 750);
  }

  function init() {
    var observer = new MutationObserver(function (mutations) {
      var shouldCheck = mutations.some(function (mutation) {
        return mutation.type === 'childList' ||
          (mutation.type === 'attributes' && mutation.target === document.body);
      });
      if (shouldCheck && document.body.classList.contains(lockClass)) scheduleCheck();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    if (document.body.classList.contains(lockClass)) scheduleCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
